/* eslint-disable semi */

const SasUtils = {
  /**
   * Vueコンポーネントか判別する
   * @param {*} target
   */
  isVueComponent (target) {
    if (
      typeof target === 'undefined' ||
      target === null ||
      typeof target !== 'object'
    ) {
      return false;
    }
    return '$nextTick' in target;
  }
}
export default SasUtils;



// WEBPACK FOOTER //
// ./src/core/libs/SasUtils.js